import React, {useState, useMemo} from 'react';

import {useModule} from '@/hooks/useModule';
import {ItemId, ItemType} from '../tags_module';
import {Button, Input} from '@mantine/core';
import {notifications} from '@mantine/notifications';

type AddTagFormProps = {
    itemType: ItemType;
    itemId: ItemId;
};

export const AddTagForm = ({itemType, itemId}: AddTagFormProps) => {
    // TODO: use better pattern than onChange etc.
    // uncontrolled components are probably better
    const [inputText, setInputText] = useState('');

    const tagsModule = useModule('Tags');
    const existingTags = tagsModule.useExistingTags();
    const tagsForItem = tagsModule.useTagsForItem(itemType, itemId);

    const availableExistingTags = useMemo(() => {
        return existingTags.filter(tag => !tagsForItem.find(itemTag => itemTag.tag === tag));
    }, [existingTags, tagsForItem]);

    const addTag = () => {
        if (tagsForItem.find(t => t.tag === inputText)) {
            notifications.show({
                title: 'Tag already exists',
                message: 'This tag is already added to this item.',
                color: 'orange',
            });
            return;
        }

        tagsModule.createTagForItem(itemType, itemId, inputText);
        setInputText('');
    };

    return (
        <div style={{border: '1px solid'}}>
            Add tag form:
            <form>
                <Input
                    type='text'
                    onChange={e => setInputText(e.target.value)}
                    value={inputText} />
                <Button
                    type='button'
                    onClick={addTag}
                    disabled={!inputText}
                >
                    Add tag
                </Button>

                <div>
                    Available existing tags:
                    <ul>
                        {availableExistingTags.map(tag => (
                            <li
                                key={tag}
                                onClick={() => tagsModule.createTagForItem(itemType, itemId, tag)}
                            >
                                {tag}
                            </li>
                        ))}
                    </ul>
                </div>
            </form>
        </div>
    );
};
